import Resp from 'src/models/resp/Resp'
import _ from 'lodash'

import router from '@/routes'
import store from '@/store'

import {ActiveTableConfig} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'
import {TableOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'

import statusComponent from '@/components/Resp/list/cols/status.vue'

// @ts-ignore
import messages from '@/lang/index'

const ActiveTableConfig: ActiveTableConfig<Resp> = {
  documentsName: messages.polls.polls1,
  onRowClick ({row}) {
    console.log('LOG: onRowClick -> row', row)
    router.push({name: 'respPage', params: {id: row.getId()}})
  },
  async find (search, filters, sortKeys, limit, offset, scope) {
    const params = {
      limit,
      offset,
      ...scope
      // sort
    }
    const result = await store.dispatch('resp/find', params)
    console.log('RESP FIND', result)
    return {
      count: result.count,
      list: result.resps
    }
  },
  filtersAndActions: {
    pageName: messages.polls.search_and_filters,
    searchFormButtonText: messages.polls.search_students,
    hideFilters: true,
    searchForm: {
      inputs: {
      },
      steps: []
    },
    filters: {},
    hiddenFilters: {}
  },
  defaultShownColumns: ['pollTitle', 'ctDate', 'status'],
  table: {
    cols: {
      pollTitle: {label: messages.polls.poll_name},
      ctDate: {label: messages.polls.poll_send_date},
      status: {label: messages.labels.status, component: statusComponent}
    }
  } as TableOptions
}
export default ActiveTableConfig